<template>
    <el-container style="height: 100%;" direction="vertical">
        <Header ref="header"></Header>

        <el-container>
            <el-main style="margin-bottom: 30px">
                <!-- customize content here -->
                <transition name="fade" mode="out-in">
                    <router-view :pageTitle.sync="pageTitle"
                                 @show-footer="isShowFooter = true"
                                 @hide-footer="isShowFooter = false"
                                 style="margin-bottom: 20px">
                        <!--Content goes here-->
                    </router-view>
                </transition>
            </el-main>
        </el-container>
        <div style="clear: both;"></div>

        <!-- translate tool -->
        <div id="WATelements"></div>
        <Footer v-if="isShowFooter"></Footer>
    </el-container>
</template>

<script>
    import Header from "./modules/Header.vue";
    import Pages from '@/router/Pages';
    import Footer from "./modules/Footer";

    export default {
        name: "Layout",
        data() {
            return {
                mallCode: null,
                pageTitle: "",
                functionScope: this.$route.meta.functionScope,
                adminMenu: Pages.systemMenu,
                mallMenu: Pages.mallMenu,
                shopMenu: Pages.shopMenu,
                isFooterFixed: false,
                isShowFooter: false
            }
        },

        components: {
            Footer,
            Header,
        },

        watch: {
        },

        computed: {

        },

        methods: {

        }
    };
</script>

<style lang="scss">
    #WATelements {
        margin-bottom: 20px;
    }

    .page-title {
        text-align: left;
    }

    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

    .app-breadcrumb {
        margin: 35px 0px;

        /deep/ .el-breadcrumb__item {
            font-size: 20px !important;
        }

        /deep/ .app-breadcrumb-item .el-breadcrumb__inner {
            font-weight: 700;
            text-decoration: none;
            -webkit-transition: color .2s cubic-bezier(.645, .045, .355, 1);
            transition: color .2s cubic-bezier(.645, .045, .355, 1);
            color: #303133 !important;
            cursor: pointer;
        }
    }

</style>
